// Function to check if a date is tomorrow
function isTomorrow(dateStr) {
  // Extract the date from the string (e.g., "Friday, 04 April")
  const parts = dateStr.split(', ');
  if (parts.length < 2) return false;
  
  const datePart = parts[1];
  
  // Create Date objects for today and the delivery date
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  
  // Format tomorrow's date to match the format used in the delivery timer
  const tomorrowDay = tomorrow.getDate().toString().padStart(2, '0');
  const tomorrowMonth = tomorrow.toLocaleString('en-US', { month: 'long' });
  
  // Check if the delivery date matches tomorrow's date
  return datePart.includes(`${tomorrowDay} ${tomorrowMonth}`) || 
         datePart.includes(`${tomorrowDay} ${tomorrowMonth.substring(0, 3)}`);
}


// Function to update the delivery date text
function updateDeliveryText() {
  const deliveryDateElements = document.querySelectorAll('.delivery_date');
  
  deliveryDateElements.forEach(element => {
    const originalText = element.textContent;
    
    // Only modify if the text doesn't already contain "Tomorrow"
    if (!originalText.includes('Tomorrow') && isTomorrow(originalText)) {
      // Extract just the date part (e.g., "04 April") from the original text
      const parts = originalText.split(', ');
      if (parts.length >= 2) {
        const datePart = parts[1];
        element.textContent = `Tomorrow, ${datePart}`;
      }
    }
  });
}


// Function to initialize and set up observers
function initTomorrowDelivery() {
  // Try to update immediately in case elements are already loaded
  updateDeliveryText();
  
  // Set up a MutationObserver to watch for changes to the DOM
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && 
          (mutation.target.classList.contains('dltimerwrapper__0') || 
           mutation.target.querySelector('.delivery_date'))) {
        updateDeliveryText();
      }
    }
  });
  
  // Start observing the document with the configured parameters
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  // Also set a few timeouts to catch any delayed rendering
  setTimeout(updateDeliveryText, 500);
  setTimeout(updateDeliveryText, 1500);
  setTimeout(updateDeliveryText, 3000);
}


// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTomorrowDelivery);
} else {
  initTomorrowDelivery();
}
